﻿(function () {

    'use strict';
    var serviceId = 'repository.longstanding';
    angular
        .module('app.services')
        .factory(serviceId, longstanding);

    longstanding.$inject = ['common', 'repository.abstract', '$http'];

    function longstanding(common, abstractRepository, $http) {
        var config = common.config;

        function Ctor(mgr) {
            this.manager = mgr;
            this.getFilters = getFilters;
            this.getCarrierList = getCarrierList;
            this.getLongstandingFilters = getLongstandingFilters;
            this.getLongstandingList = getLongstandingList;
            this.getLongstandingListExcel = getLongstandingListExcel;
        }

        abstractRepository.extend(Ctor);
        return Ctor;

        function getFilters() {
            var authData = common.localStorageService.get('authorizationData');
            var codeRole = authData ? authData.userRole : "";
            return common.httpGet(config.basePaths.Base_Path_Resources + 'reportList/GetContainerReceptionFilters?legend=longstanding&codeRole=' + codeRole);
        }

        function getCarrierList() {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'reportList/GetCarrierList');
        }

        function getLongstandingFilters() {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'reportList/GetLongstandingFilters');
        }

        function getLongstandingList(model) {
            return common.httpPost(config.basePaths.Base_Path_Resources + 'reportList/GetLongstandingList', model);
        }

        function getLongstandingListExcel(model, fileName) {
            common.httpPostFile(config.basePaths.Base_Path_Resources + 'reportList/PrintLongstandingReport', model, fileName);
        }
    }

})();
